import {AccountSearchInterface} from "../../pages/customer/correspondent/list/interface/searchInterface";
import {ProjectResType} from "../../pages/customer/project/interface";
import {DefaultResType, ErrorType, ResponseResType, SuccessType,} from "../../types/common/response";
import {baseApi} from "../../util/axiosConfig";

/**
 * 거래처 - 프로젝트
 */
const url = "api/customer/project/";

/**
 * 프로젝트 리스트 조회
 * @param data
 * @returns
 */
export async function readProjectListApi(
    data: AccountSearchInterface
): Promise<
    ResponseResType<{ totalCount: number; list: ProjectResType[] }> | ErrorType
> {
    const response = await baseApi.post(url + "read_project_list", data);
    return response?.data;
}

export async function readProjectDetailApi(data: number): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "read_project_detail", {id: data});
    } catch (err: any) {
        return err?.response;
    }
}

/**
 * 프로젝트 등록
 * @param data
 * @returns
 */
export async function createProjectApi(
    data: ProjectResType
): Promise<SuccessType | ErrorType> {
    const response = await baseApi.post(url + "create_project", data);
    return response?.data;
}

/**
 * 프로젝트 수정
 * @param data
 * @returns
 */
export async function updateProjectApi(
    data: ProjectResType
): Promise<SuccessType | ErrorType> {
    const response = await baseApi.post(url + "update_project", data);
    return response?.data;
}

/**
 * 프로젝트 삭제
 * @param data
 * @returns
 */
export async function deleteProjectApi(
    data: { id: number }[]
): Promise<SuccessType | ErrorType> {
    const response = await baseApi.post(url + "delete_project", data);
    return response?.data;
}

/**
 * 프로젝트 엑셀 내보내기
 * @param data
 * @returns
 */
export async function exportProjectExcelApi(
    data: AccountSearchInterface
): Promise<Blob | ArrayBuffer | Uint8Array | string | ErrorType> {
    const response = await baseApi.post(url + "export_project_excel", data, {
        responseType: "blob",
    });

    return response?.data;
}
